/* Stroma product cards ("+ Add" instead of the bag icon / hover size overlay).
   Cards for products on the Stroma template (template_suffix 'stroma') render the
   theme's usual .plp-atc-container, tagged st-card-addwrap, so the theme swatch code
   (changeVariantImage) keeps updating the button's data-handle and the size rows.
   Same behaviour as the Stroma page "+ Add":
     mobile  → theme quick-add sheet (openQuickView)
     desktop → white "Select size" list anchored beside the button; rows add via plpAtc */
(function () {
  'use strict';
  if (window.stromaCardAdd) return;
  var dd = null, list = null;

  function build() {
    dd = document.createElement('div');
    dd.className = 'wishlist_dropdown st-card-dd-pop';
    dd.innerHTML = '<div class="lottosmheading">Select Size</div><ul></ul>';
    list = dd.lastChild;
    document.body.appendChild(dd);
    dd.addEventListener('mouseleave', close);
    document.addEventListener('click', function (e) {
      if (!dd.classList.contains('active')) return;
      if (dd.contains(e.target) || (dd.__for && dd.__for.contains(e.target))) return;
      close();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    window.addEventListener('scroll', function () { if (dd.classList.contains('active')) place(); }, { passive: true });
    window.addEventListener('resize', close);
  }
  function close() {
    if (!dd) return;
    dd.classList.remove('active');
    if (dd.__for) dd.__for.classList.remove('active');
    dd.__for = null;
  }
  function place() {
    var btn = dd.__for;
    if (!btn) return;
    var b = btn.getBoundingClientRect();
    var w = dd.offsetWidth, h = dd.offsetHeight, gap = 12;
    var left = b.right + gap;
    if (left + w > window.innerWidth - 8) left = Math.max(8, b.left - w - gap);
    var top = b.top + b.height / 2 - h / 2;
    top = Math.max(8, Math.min(top, window.innerHeight - h - 8));
    dd.style.left = Math.round(left) + 'px';
    dd.style.top = Math.round(top) + 'px';
  }

  window.stromaCardAdd = function (btn, ev) {
    if (ev) { ev.preventDefault(); ev.stopPropagation(); }
    var handle = btn.getAttribute('data-handle');
    var wrap = btn.closest('.plp-atc-container');
    var src = wrap && wrap.querySelector('.wishlist_dropdown');
    var rows = src ? src.querySelectorAll('.plp-size-value') : [];
    var mobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    if (mobile || !rows.length) {
      if (typeof window.openQuickView === 'function') window.openQuickView(btn, handle);
      else window.location.href = '/products/' + handle;
      return;
    }
    if (!dd) build();
    if (dd.classList.contains('active') && dd.__for === btn) { close(); return; }
    close();
    list.innerHTML = '';
    // Clone at click time: the swatch code rewrites these rows for the shown colour.
    Array.prototype.forEach.call(rows, function (r) {
      var row = r.cloneNode(true);
      row.removeAttribute('onclick');
      row.addEventListener('click', function (e) {
        e.stopPropagation();
        if (typeof window.plpAtc === 'function') window.plpAtc(row);
      });
      list.appendChild(row);
    });
    dd.__for = btn;
    dd.classList.add('active');
    btn.classList.add('active');
    place();
  };
})();
